<template>
  <div class="link"
       :style="style"
       @click="click"
       v-show="currentPageLink"
       :class="className">
    <div v-if="data.linktype!=='video'"
         class="point-bg abs-center"></div>
    <div v-if="data.linktype!=='video'"
         class="point abs-center"></div>
    <div v-if="videoVisible"
         :id="videoId"
         style="width:100%;height:100%"></div>
  </div>
</template>
<script>
import { validURL } from '@/utils';

export default {
  name: 'linkItem',
  props: {
    data: Object,
    id: Number,
    first: Array,
  },
  data() {
    return {
      player: '',
      videoVisible: false,
      currentPageLink: false,
    };
  },
  mounted() {
    /* eslint-disable */
    /*this.$nextTick(() => {
      if (this.data.linktype === "video"&&this.data.pageid===this.currentPageId) {
        this.player = polyvPlayer({
          wrap: '#'+this.videoId,
          width: "100%",
          height: "100%",
          vid: this.data.url,
          autoplay: false,
          forceH5: true,
          skinLocation: 0,
        });
        //加载完如果是当前页自动播放, 由于浏览器原因不起作用
        if(this.data.pageid===this.currentPageId){
            this.player.HTML5.play()
        }
      }
    });*/
  },
  computed: {
    videoId() {
      return "v" + this.data.pageid + "_" + this.id;
    },
    style() {
      const obj = {};
      obj.top = `${this.data.y}px`;
      obj.left = `${this.data.x}px`;
      obj.width = `${this.data.width}px`;
      obj.height = `${this.data.height}px`;
      obj.backgroundImage = `url(${this.data.file})`;
      const obj2 = {};
      obj2.top = `${this.data.y / 5.3}%`;
      obj2.left = `${this.data.x / 4}%`;
      obj2.width = `${this.data.width / 4}%`;
      obj2.height = `${this.data.height / 5.3}%`;
      obj2.backgroundImage = `url(${this.data.file})`;
      return obj2;
    },
    className() {
      if (this.data.styleid === 3) {
        return `modal${this.data.title}`;
      }
      if (this.data.linktype === "video") {
        return `video`;
      }
      return `style${this.data.styleid}`;
    },
    currentPageId() {
      return this.$store.state.currentPageId;
    },
  },
  watch: {
    "$store.state.videoId":{
        immediate:true,
        handler(val){
            if (this.data.linktype === "video"&&this.player.HTML5) {
            if(val!==this.videoId){
                this.player.j2s_pauseVideo();
            }
            }
        }
    },
    currentPageId: {
      immediate: true,
      handler(val) {
        let isHome= this.$store.state.currentPage===0
        //未必是连续数字，最好从数组中选取
         let n= Number(this.data.pageid)+1
        this.currentPageLink = false
          if(isHome===0){
             this.currentPageLink =(val === this.data.pageid)
          }else{
             this.currentPageLink = (val === this.data.pageid||val=== n+'')
          }
        

        if (this.data.linktype === "video") {
          //是否首页 首页则不播放第二页
          if (this.currentPageLink) {
            //当前页面加载视频
            this.videoVisible = true;
            this.$nextTick(() => {
              if(this.player){
               this.player.j2s_pauseVideo();
               this.player.destroy();
               this.player = ""; 
            }    
              this.player = polyvPlayer({
                wrap: "#" + this.videoId,
                width: "100%",
                height: "100%",
                vid: this.data.url,
                autoplay: false,
                forceH5: true,
                skinLocation: 1,
                ban_history_time:"on"
              });
              //第一个视频自动播放
              if(this.first.indexOf(this.data)===0){
                 this.player.HTML5.play();
                 this.$store.commit("updateVideoId",{videoId:this.videoId})
              }
              let that = this
              this.player.on('s2j_onVideoPlay',function(e) {
                //发送停止事件
                that.$store.commit("updateVideoId",{videoId:that.videoId})
                this.$forceUpdate();
              });  
            });
          } else {
            //非当前页面清除视频
            if(this.player){
               this.player.j2s_pauseVideo();
               this.player.destroy();
               this.player = ""; 
               //console.log("unload");
            }            
            this.videoVisible = false;
          }
        }
      },
    },
  },
  methods: {
    click(e) {
      e.stopPropagation();
      e.cancelBubble = true;
      if (this.data.linktype === "external") {
        if (validURL(this.data.url)) {
          window.open(this.data.url);
        }
      } else if (this.data.linktype === "modal") {
        if (validURL(this.data.url)) {
          this.$store.commit("updateModalStatus", {
            modal: {
              show: true,
              mode: "ifram",
              value: this.data.url,
            },
          });
        } else {
          this.$store.commit("updateModalStatus", {
            modal: {
              show: true,
              mode: "video",
              value: this.data.url,
            },
          });
        }
      } else {
        this.$store.commit("updateCurrentPageId", {
          currentPageId: this.data.url,
        });
        this.$store.commit("updateView", {
          view: "book",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.link.style1 {
  width: 100px;
  height: 100px;
  position: absolute;
  cursor: pointer;
  background: #ff980040;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  animation: fadding 1s infinite;
}
.link.video {
  width: 100px;
  height: 100px;
  position: absolute;
  cursor: pointer;
  background: black;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.link.modal {
  width: 100px;
  height: 100px;
  position: absolute;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .point-bg {
    animation: fadding 1s infinite;
    border-radius: 100px;
    width: 45px;
    height: 45px;
    background-color: #ffffff;
    animation-direction: alternate;
    opacity: 0;
  }
  .point {
    border-radius: 100px;
    width: 15px;
    height: 15px;
    border: 8px solid white;
    background-color: #ff9f00;
  }
}
.link.modal3d {
  width: 100px;
  height: 100px;
  position: absolute;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .point-bg {
    animation: fadding 1s infinite;
    border-radius: 100px;
    width: 45px;
    height: 45px;
    background-color: #ffffff;
    animation-direction: alternate;
    opacity: 0;
  }
  .point {
    border-radius: 100px;
    width: 25px;
    height: 25px;
    border: 5px solid white;
    background-color: #ff9f00;
    background-image: url("~@/assets/css/sd.png");
    background-size: 15px;
    background-repeat: no-repeat;
    background-position: center;
  }
}
.link.modalvideo {
  width: 100px;
  height: 100px;
  position: absolute;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .point-bg {
    animation: fadding 1s infinite;
    border-radius: 100px;
    width: 45px;
    height: 45px;
    background-color: #ffffff;
    animation-direction: alternate;
    opacity: 0;
  }
  .point {
    border-radius: 100px;
    width: 25px;
    height: 25px;
    border: 5px solid white;
    background-color: #ff9f00;
    background-image: url("~@/assets/css/video.png");
    background-size: 15px;
    background-repeat: no-repeat;
    background-position: center;
  }
}
@keyframes fadding {
  from {
    opacity: 0.2;
  }
  to {
    opacity: 0.5;
  }
}
</style>
